import { AccessEntries, FEATURE_ACCESS } from "../utils/accessEntries";
import classes from "../css/modules/navigation.module.scss";
import { Tooltip } from "@mui/material";
import { Access } from "./Access";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { apiUrls } from "../utils/api";
import { add } from "../redux/snackbar";
import { useApiClient } from '../components/ApiProvider';

export function SyncAllProjects() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const apiClient = useApiClient();

  const onSyncAll = async () => {
    pendo.track("Sync all projects", {
    });
    const resp = await apiClient.post(apiUrls.SyncAllProjectsAndOrders);
    const msg = await resp.text();
    dispatch(
      add({
        message: t(msg.replace(/['"]+/g, "")),
        autoHideDuration: 5000,
      })
    );
  };
  return (
    <Access entry={AccessEntries.SyncAllProjects} accessValues={FEATURE_ACCESS.Enabled}>
      <Tooltip title={t("Sync all projects")}>
        <button className={classes.syncAll} onClick={onSyncAll} aria-label={t("Sync all projects")}>
          <span className="ico icon-tab deg-90" />
        </button>
      </Tooltip>
    </Access>
  );
}
